import type { PropsWithChildren } from 'react';
import React from 'react';

import { applyTestIdData } from 'Utilities/helpers';

import styles from './VehicleGridV2.module.scss';

export const VehicleGridV2: React.FC<PropsWithChildren> = ({ children }) => (
	<ul className={styles.grid} {...applyTestIdData('vehicle-grid-v2')}>
		{children}
	</ul>
);
